import { Injectable } from '@angular/core';
import { LocalStorage } from '@x/common/storage';
import { IShopAuthToken, IShopOrderToken } from '@x/ecommerce/shop-client';

@Injectable({ providedIn: 'root' })
export class ShopStorage extends LocalStorage {
  set channel(channel: string | null | undefined) {
    if (!channel) {
      this.removeItem('x-channel');
      return;
    }

    this.setItem('x-channel', channel);
  }
  get channel(): string | null {
    return this.getItem('x-channel');
  }

  set userToken(token: IShopAuthToken | null) {
    if (!token) {
      this.removeItem('x-user-token');
      return;
    }

    this.setItem('x-user-token', token);
  }
  get userToken(): IShopAuthToken | null {
    return this.getItem('x-user-token');
  }

  set orderToken(token: IShopOrderToken | null) {
    if (!token) {
      this.removeItem(`x-${this.channel}-order-token`);
      return;
    }

    this.setItem(`x-${this.channel}-order-token`, token);
  }

  get orderToken(): IShopOrderToken | null {
    return this.getItem(`x-${this.channel}-order-token`);
  }

  // set regionStorage(region: RegionStorage | null) {
  //   if (!region) {
  //     this.removeItem(`x-${this.channel}-region`);
  //     return;
  //   }
  //
  //   this.setItem(`x-${this.channel}-region`, region);
  // }

  // get regionStorage(): RegionStorage | null {
  //   return this.getItem(`x-${this.channel}-region`);
  // }

  set channelNotification(notification: { visible: boolean; message: string } | null) {
    this.setItem(`x-${this.channel}-notification`, notification);
  }

  get channelNotification(): { visible: boolean; message: string } | null {
    return this.getItem(`x-${this.channel}-notification`);
  }

  set recentSearches(searches: { searchText: string; timestamp: number }[] | null) {
    if (!searches) this.removeItem('x-recent-searches');
    this.setItem('x-recent-searches', searches);
  }

  get recentSearches(): { searchText: string; timestamp: number }[] | null {
    return this.getItem('x-recent-searches');
  }
}
